export const debounce = (func, wait = 300) => {
  let timeout;

  const executedFunction = (...args) => {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };

  executedFunction.cancel = () => {
    clearTimeout(timeout);
    timeout = null;
  };

  return executedFunction;
};
